import { Location } from '../../types/location';
import { RootState } from '../rootReducer';
import { Sites } from './actions';

export const getSitesState = (state: RootState): Sites => state.sitesObject.sites;
export const getDraggedSiteState = (state: RootState): number => state.sitesObject.draggedSite;
export const getGlobalLocationsState = (state: RootState): Array<Location> => state.sitesObject.globalLocations;
export const getIgnoreFocusedState = (state: RootState): boolean => state.sitesObject.ignoreFocused;
export const getIsSitesLoading = (state: RootState) : boolean => state.sitesObject.isLoading;
